import farmSo from "stores/farm";
import metaSo from "stores/metadata";
import valuesSo from "stores/values";
import { Metadata } from "types/Metadata";
import { Component } from "types/Service";



/** Modello di un PLC Alert */
export interface AlertModel {
	code: string
	alias: string
	description: string

	component?: Component

	/** indica che l'ALERT è stato ACK (mutato) dall'utente. */
	isAck?: boolean
	/** se presente indica l'alias del PLC-VALUE da leggere per capire se l'allarme è ACK o no */
	ackAlias?: string
}

/** 
 * restituisce tutti gli ALERT presenti nei metadata 
 */
export function getPLCAlerts() {
	return (metaSo.state.metadata ?? [])
		.filter(meta => meta.group == "ALLARMI")
		.map(meta => alertFromMetadata(meta))
}

/**
 * restituisce tutti gli ALERT presenti nei metadata 
 * associati ad un COMPONENT specifico
 */
export function getPLCAlertsByComponentCode (componentCode: string) {
	return getPLCAlerts().filter(alert => alert.component?.code == componentCode)
}

/** 
 * restituisce solo gli ALERT attivi
 * Aggiorna il loro ACK
 */
export function updatePLCAlerts(alerts: AlertModel[]) {
	if (!alerts) return []
	return alerts
		.filter(alert => valuesSo.getBoolByAlias({ alias: alert.alias, code: alert.code }))
		.map(alert => alertUpdateAck(alert))
}

/** costruisco un AlertModel da un Metadata */
function alertFromMetadata(meta: Metadata): AlertModel {
	if (!meta.alias) return null

	// ACK
	const start = meta.alias.indexOf("fAL")
	let ackAlias: string, isAck: boolean
	if (start != -1) {
		ackAlias = `ALM${meta.alias.slice(start + 3, start + 6)}_Mute`
		//isAck = valuesSo.getBoolByAlias({ alias: ackAlias, code: meta.serviceCode })
	}

	// DESCRIPTION
	const descs = meta.description?.match(/\[([^\]]+)\]/g)?.map(item => item.slice(1, -1))
	const description = descs?.[2] ?? meta.description ?? ""
	const tag = descs?.[0]

	// COMPONENT
	const components = farmSo.getComponentsByNats(meta.serviceCode)
	let component = null
	if (!!tag && !!components) {
		component = components.length == 1
			? components[0]
			: components.find(cmp => cmp.tags?.some(t => tag.includes(t)) ?? false)
	}

	return {
		code: meta.serviceCode,
		alias: meta.alias,
		description,
		component: component,
		//isAck,
		ackAlias,
	}
}

/** leggo il registro del PLC e aggiorno il valore dell AlertModel  */
function alertUpdateAck(alert: AlertModel) {
	if (!alert) return null
	if (!alert.ackAlias) return alert
	alert.isAck = valuesSo.getBoolByAlias({ alias: alert.ackAlias, code: alert.code })
	return alert
}
